import { create } from 'zustand';
import type { AppSurface } from '../components/BottomNav';

interface UiState {
  surface: AppSurface;
  historyOpen: boolean;
  streamingConversationIds: Set<string>;
  setSurface: (surface: AppSurface) => void;
  setHistoryOpen: (open: boolean) => void;
  toggleHistory: () => void;
  startStreaming: (conversationId: string) => void;
  stopStreaming: (conversationId: string) => void;
}

export const useUiStore = create<UiState>((set) => ({
  surface: 'chat',
  historyOpen: false,
  streamingConversationIds: new Set<string>(),
  setSurface: (surface) => set({ surface }),
  setHistoryOpen: (open) => set({ historyOpen: open }),
  toggleHistory: () => set((s) => ({ historyOpen: !s.historyOpen })),
  startStreaming: (conversationId) =>
    set((s) => ({
      streamingConversationIds: new Set(s.streamingConversationIds).add(
        conversationId,
      ),
    })),
  stopStreaming: (conversationId) =>
    set((s) => {
      const next = new Set(s.streamingConversationIds);
      next.delete(conversationId);
      return { streamingConversationIds: next };
    }),
}));
